import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const Tlaki = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Tlaki"
          subtitle="Tlaki za zunanje in notranje površine"
          imageSrc="/lovable-uploads/a5655ddf-0e77-4b4c-b45a-06c871a562d0.png"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Tlaki"
            subtitle="Tlaki za zunanje in notranje površine"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Kamniti tlaki so idealna izbira za zunanje površine, kot so terase, dovozi in vrtne poti.
              Odlikujejo jih odpornost na vremenske vplive, dolgotrajnost in minimalno vzdrževanje.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Tlaki 1" },
              { src: "/placeholder.svg", alt: "Tlaki 2" },
              { src: "/placeholder.svg", alt: "Tlaki 3" },
              { src: "/placeholder.svg", alt: "Tlaki 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Tlaki;